import { render, staticRenderFns } from "./RoasterTables.vue?vue&type=template&id=16cd4fbe&scoped=true&"
import script from "./RoasterTables.vue?vue&type=script&lang=ts&"
export * from "./RoasterTables.vue?vue&type=script&lang=ts&"
import style0 from "./RoasterTables.vue?vue&type=style&index=0&id=16cd4fbe&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16cd4fbe",
  null
  
)

export default component.exports